import React from 'react'

export interface MessagePreviewProps {
  content: string
  maxLength?: number
  className?: string
}

/**
 * Truncated message preview for cards and lists
 *
 * Features:
 * - Truncates content to maxLength characters
 * - Adds ellipsis when truncated
 * - Removes markdown formatting for clean preview
 * - Single line display
 */
export const MessagePreview: React.FC<MessagePreviewProps> = ({
  content,
  maxLength = 100,
  className = '',
}) => {
  // Remove markdown formatting for clean preview
  const cleanContent = content
    .replace(/[*_~`#]/g, '') // Remove markdown symbols
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1') // Extract link text
    .replace(/\n+/g, ' ') // Replace newlines with spaces
    .trim()

  const truncated =
    cleanContent.length > maxLength
      ? `${cleanContent.slice(0, maxLength)}...`
      : cleanContent

  return (
    <p
      className={`text-sm text-gray-600 dark:text-gray-400 truncate ${className}`}
    >
      {truncated}
    </p>
  )
}
